import React from 'react'

import { Typography } from '@mui/material'
import { PaperPanel } from '../Panel/PaperPanel'

interface WithoutResultsPanelProps {}

export const WithoutResultsPanel: React.FC<WithoutResultsPanelProps> = () => {
  return (
    <PaperPanel centerText>
      <Typography variant='button'>
        Los criterios de busqueda no han arrojado resultados.
      </Typography>
    </PaperPanel>
  )
}
